import { RootState } from '../store';

export const selectUnsavedChanges = (state: RootState) => state.unsavedChanges;
